export enum MyLearningPageContentSections {
  SAVED = 'saved',
  IN_PROGRESS = 'in-progress',
  COMPLETE = 'complete',
  RECENTLY_VIEWED = 'recently-viewed',
}

export const MAX_ITEMS_SHOWN = 5;
